$validFieldCheck.keypress(function(e) {
    	var erlaubteZeichen = /^[a-zA-z0-9äÄüÜöÖß!#$%*+,\-.\/:;=?@\\_()\[\]\{\}|~\t]+$/;
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (erlaubteZeichen.test(str)) {
            return true;
        }
        e.preventDefault();
        return false;
});
